import Utils from '@/common/utils/utils';
import EmailRichtext from '../../../../project/EmailResponseSetting/EmailRichtext';
import trI18n from '@/common/utils/trI18n';
import { tr, trLabel } from '@/common/utils/tr';
import { useTranslationSubscription } from '@/hooks/useTranslation';
import useOnDemandContentDisplay from '@/component/multiLanguage/hooks/useOnDemandContentDisplay';

function ContentMailBody({
    fieldData,
    isCustomerMail,
    isDeliverTicket,
    isDisableLink,
    isDisableEdit,
    onclickReplyTicket,
    setIsEditedCurrentTicket,
    currentMailBody,
    setCurrentMailBody,
    contentId,
    displayMode
}) {
    return (
        <>
            {isCustomerMail || isDeliverTicket ? (
                <MailBodyViewOnly
                    fieldData={fieldData}
                    isCustomerMail={isCustomerMail}
                    isDeliverTicket={isDeliverTicket}
                    isDisableLink={isDisableLink}
                    isDisableEdit={isDisableEdit}
                    onclickReplyTicket={onclickReplyTicket}
                    displayMode={displayMode}
                    contentId={contentId}
                />
            ) : (
                <div className="form-addTicket">
                    <EmailRichtext
                        label={trLabel('本文')}
                        disable={isDisableEdit}
                        richtextValue={currentMailBody}
                        setRichtextValue={setCurrentMailBody}
                        setIsEdited={setIsEditedCurrentTicket}
                        isRequired={true}
                        isValidateWhenBlur={true}
                        contentId={contentId}
                        onDemandFieldKey={fieldData?.id}
                        onDemandDisplayMode={displayMode}
                    />
                </div>
            )}
        </>
    );
}

export default ContentMailBody;

const MailBodyViewOnly = ({
    fieldData,
    isCustomerMail,
    isDisableLink,
    isDisableEdit,
    onclickReplyTicket,
    displayMode,
    contentId,
}) => {
    // Re-render when the translation dictionary loads/extends so tr() text updates.
    useTranslationSubscription();
    let bodyHtml = '';
    if (Utils.isValidJSONString(fieldData?.value)) {
        bodyHtml = JSON.parse(fieldData?.value);
        return (
            <MailBodyHtmlView
                bodyHtml={bodyHtml}
                fieldData={fieldData}
                contentId={contentId}
                isCustomerMail={isCustomerMail}
                isDisableLink={isDisableLink}
                isDisableEdit={isDisableEdit}
                onclickReplyTicket={onclickReplyTicket}
            />
        );
    } else {
        return (
            <div className="form-addTicket">
                <EmailRichtext
                    label={trLabel('本文')}
                    disable={true}
                    richtextValue={fieldData}
                    setRichtextValue={() => {}}
                    setIsEdited={() => {}}
                    isRequired={true}
                    isValidateWhenBlur={true}
                    isCustomerMail={isCustomerMail}
                    isDisableLink={isDisableLink}
                    isDisableEdit={isDisableEdit}
                    onclickReplyTicket={onclickReplyTicket}
                    contentId={contentId}
                    onDemandFieldKey={fieldData?.id}
                    onDemandDisplayMode={displayMode}
                />
            </div>
        );
    }
};

const MailBodyHtmlView = ({
    bodyHtml,
    fieldData,
    contentId,
    isCustomerMail,
    isDisableLink,
    isDisableEdit,
    onclickReplyTicket
}) => {
    // On-demand translation: when the 翻訳 toggle is ON and a translation exists,
    // render the translated HTML body instead of the original. Read-only view, so
    // nothing is written back to the edit state.
    const { displayValue: onDemandBody, isShowingTranslation } = useOnDemandContentDisplay(
        bodyHtml,
        { contentId, fieldKey: fieldData?.id }
    );

    const displayHtml = isShowingTranslation ? onDemandBody : bodyHtml;

    return (
        <div className="form-addTicket">
            <div className="mailBody-title-wrap">
                <div className="cell-prod-status gap-8">
                    <label className="form-addTicket-label">{trLabel('本文')}</label>
                    {true && <span className="required">*</span>}
                </div>
                {isCustomerMail && (
                    <span
                        className={`send-msg-hyper-link ${
                            isDisableLink || isDisableEdit ? 'send-msg-hyper-link-disable' : ''
                        }`}
                        onClick={() => {
                            if (isDisableLink || isDisableEdit) return;
                            onclickReplyTicket();
                        }}
                    >
                        {tr('このメッセージに返信')}
                    </span>
                )}
            </div>
            <div className="mailBody-content">
                <div dangerouslySetInnerHTML={{ __html: displayHtml }} />
            </div>
        </div>
    );
};
